import { createFileRoute } from '@tanstack/react-router';

import { DmaImpactsPage } from '@/features/esg/dma/components/DmaImpactsPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/impacts')({
  component: DmaImpactsRoute,
});

function DmaImpactsRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaImpactsPage assessmentId={assessmentId} />;
}
